export default __webpack_public_path__ + "static/media/studioCareer.ed8363e7.png";